import _ from "./_nativeCreate.js";
var h = _, i = "__lodash_hash_undefined__";
function r(a, t) {
  var e = this.__data__;
  return this.size += this.has(a) ? 0 : 1, e[a] = h && t === void 0 ? i : t, this;
}
var n = r;
export {
  n as default
};
//# sourceMappingURL=_hashSet.js.map
